import { AlternateTimeline } from '../../Components/AlternateTimeline'
import escritorio1 from '../../../../Assets/img_escritorio_1.png'
import escritorio2 from '../../../../Assets/img_escritorio_2.png'
import escritorio3 from '../../../../Assets/img_escritorio_3.png'
import icon1 from '../../../../Assets/icon_nos_1.png'
import icon2 from '../../../../Assets/icon_nos_2.png'
import icon3 from '../../../../Assets/icon_nos_3.png'
import icon4 from '../../../../Assets/icon_nos_4.png'
import icon5 from '../../../../Assets/icon_nos_5.png'
import photo1 from '../../../../Assets/Emerson.png'
import photo2 from '../../../../Assets/Cadu.png'
import photo3 from '../../../../Assets/Jef.png'
import photo4 from '../../../../Assets/Lucas.png'
import photo5 from '../../../../Assets/Lee.png'
import photo6 from '../../../../Assets/Paulo.png'
import * as S from './styles'

const CARDS = [
  {
    year: '2021',
    title: 'O início de tudo',
    text: 'Fundação da Bindflow com propósito de unir tecnologia e pessoas. Primeiros clientes e construção do time inicial. Um ano de coragem, aprendizado e primeiras conquistas',
    icon: icon1
  },
  {
    year: '2022',
    title: 'Crescimento com propósito',
    text: 'Estruturação de equipes, expansão de projetos e consolidação da cultura.Crescer de forma sustentável exigiu adaptação e visão de futuro.',
    icon: icon2
  },
  {
    year: '2023',
    title: 'Consolidação e inovação',
    text: 'Mudança para o ecossistema Hotmilk, ampliando nossa presença em inovação.Um passo importante na jornada de crescimento da Bindflow.',
    icon: icon3
  },
  {
    year: '2024',
    title: 'Expansão e reconhecimento',
    text: 'Ano marcado pelo M&A com a Compwire, novas possibilidadese a conquista do selo GPTW, validando nossa cultura forte e inspiradora.',
    icon: icon4
  },
  {
    year: '2025',
    title: 'Foco e evolução contínua',
    text: 'Fortalecimento da cultura organizacional efoco no desenvolvimento de produtos e inovação constante.',
    icon: icon5
  },
]

const PARTNER = [
  {
    img: photo1,
    name: 'Emerson Martens',
    jobTitle: 'CEO'
  },
  {
    img: photo2,
    name: 'Carlos Reikdal',
    jobTitle: 'CSO'
  },
  {
    img: photo3,
    name: 'Jeferson Passos',
    jobTitle: 'COO '
  },
  {
    img: photo4,
    name: 'Lucas Moraes',
    jobTitle: 'CIO'
  },
  {
    img: photo5,
    name: 'Lee Richard',
    jobTitle: 'CPO'
  },
  {
    img: photo6,
    name: 'Paulo Zung',
    jobTitle: 'CTO'
  },
]

export const ContentSection = () => {
  return (
    <S.Wrapper>
      <S.SideCol>
        <S.LeftCol>
          <h4>
            Estrutura pronta para lhe atender
            e lhe entregar as melhores soluções.
          </h4>

          <p>
            Na <strong>Bindflow</strong>, acreditamos que <strong>tecnologia e colaboração</strong> são os alicerces para gerar resultados duradouros. Nossa <strong>estrutura moderna e integrada</strong> foi cuidadosamente planejada para unir <strong>profissionais experientes</strong>, metodologias consolidadas e uma cultura orientada à <strong>excelência e inovação contínua</strong>.
          </p>

          <p>
            Mais do que desenvolver sistemas, <strong>criamos valor</strong> através de soluções digitais que impulsionam negócios e fortalecem relações. Trabalhamos lado a lado com nossos parceiros para compreender seus desafios, alinhar expectativas e transformar ideias em resultados reais, entregando <strong>eficiência, agilidade e segurança</strong> em cada projeto.
          </p>

          <p>
            Nosso <strong>comprometimento com a seriedade e a transparência</strong> é refletido em cada etapa do processo — do planejamento à execução. Valorizamos a confiança construída com nossos clientes e buscamos sempre superar as expectativas por meio de <strong>tecnologia de ponta, gestão inteligente e atendimento humano e próximo</strong>.
          </p>

          <p>
            Com uma equipe <strong>multidisciplinar, criativa e apaixonada pelo que faz</strong>, a Bindflow se consolida como uma parceira estratégica capaz de conectar <strong>pessoas, processos e performance</strong>. Cada solução é pensada para gerar impacto, otimizar recursos e criar <strong>novas oportunidades</strong> para o crescimento sustentável de quem confia em nós.
          </p>

        </S.LeftCol>

        <S.RightCol>
          <S.Tile src={escritorio1} alt="Escritório 1" />
          <S.Tile src={escritorio2} alt="Escritório 2" />
          <S.Tile src={escritorio3} alt="Escritório 3" />
        </S.RightCol>
      </S.SideCol>

      <S.CardsBox >
        <S.Card>
          <h4>
            Propósito
          </h4>
          <p>
            A Bind encontra o melhor de nós, potencializa nosso brilho individual e coletivo, causando transformação pessoal, crescimento e paixão por tech em um ambiente de respeito e paz.
          </p>
        </S.Card>

        <S.Card>
          <h4>
            Visão
          </h4>
          <p>
            A Bind cresce sendo uma Provedora de Tecnologia e investe em produtos e inovação para um ecossistema de crescimento plural.
          </p>
        </S.Card>

      </S.CardsBox>

      <div
        style={{
          margin: '0 auto',
        }}
      >
        <AlternateTimeline items={CARDS} />
      </div>

      <S.PartnersSection>
        <S.TopShadow aria-hidden />
        <S.PartnersGrid>
          {PARTNER.map((p, i) => (
            <S.PartnerCard key={p.name + i}>
              <S.Photo src={p.img} alt={p.name} />
              <S.ShadowPhoto></S.ShadowPhoto>
              <S.Info>
                <S.Name>{p.name}</S.Name>
                <S.Job>{p.jobTitle}</S.Job>
              </S.Info>
            </S.PartnerCard>
          ))}
        </S.PartnersGrid>
      </S.PartnersSection>
    </S.Wrapper >
  )
}
